import { render, staticRenderFns } from "./LoadingPanel.vue?vue&type=template&id=7b504350"
import script from "./LoadingPanel.vue?vue&type=script&lang=js"
export * from "./LoadingPanel.vue?vue&type=script&lang=js"
import style0 from "./LoadingPanel.vue?vue&type=style&index=0&id=7b504350&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b504350')) {
      api.createRecord('7b504350', component.options)
    } else {
      api.reload('7b504350', component.options)
    }
    module.hot.accept("./LoadingPanel.vue?vue&type=template&id=7b504350", function () {
      api.rerender('7b504350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingPanel.vue"
export default component.exports